import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, ShieldCheck, ArrowRight } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-96">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900 to-navy-800" data-id="element-97" />
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full max-h-[600px] bg-gold-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-98" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-99">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row" data-id="element-100">
          {/* Left Side: Offer Details */}
          <div className="p-10 md:p-12 md:w-3/5 flex flex-col justify-center" data-id="element-101">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6 font-serif" data-id="element-102">
              Empieza a dormir mejor esta noche
            </h2>
            <p className="text-lg text-navy-600 mb-8" data-id="element-103">
              Obtén acceso inmediato a todo el sistema Triada Noche Clara y
              recupera tu energía vital.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-104">
              {['Plan completo de 6 semanas (PDF)', 'Diario de sueño imprimible', 'Guía de higiene del sueño', 'Soporte prioritario por email'].map((item, i) => <li key={i} className="flex items-center gap-3 text-navy-800 text-lg" data-id="element-105">
                  <div className="bg-green-100 p-1 rounded-full" data-id="element-106">
                    <Check className="w-4 h-4 text-green-600" data-id="element-107" />
                  </div>
                  {item}
                </li>)}
            </ul>

            <div className="flex items-center gap-2 text-navy-600 text-sm bg-cream-50 p-3 rounded-lg self-start" data-id="element-108">
              <ShieldCheck className="w-5 h-5 text-gold-600" data-id="element-109" />
              <span data-id="element-110">30 días de garantía — devolución sin preguntas</span>
            </div>
          </div>

          {/* Right Side: Pricing & Button */}
          <div id="pricing-cta" className="bg-cream-100 p-10 md:p-12 md:w-2/5 flex flex-col justify-center items-center text-center border-l border-cream-200" data-id="element-111">
            <p className="text-navy-600 font-medium uppercase tracking-wider text-sm mb-2" data-id="element-112">
              Precio Único
            </p>
            <div className="flex items-baseline gap-1 mb-6" data-id="element-113">
              <span className="text-5xl font-bold text-navy-900" data-id="element-114">$6.39</span>
              <span className="text-xl text-navy-600" data-id="element-115">USD</span>
            </div>

            <a href="https://www.vidasenbienestar.com/cart/48245974663387:1" target="_blank" rel="noopener noreferrer" className="w-full bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold text-lg py-4 px-6 rounded-xl shadow-lg shadow-gold-500/20 transition-all transform hover:scale-105 mb-4 flex items-center justify-center gap-2" data-id="element-116">
              Obtener Acceso
              <ArrowRight className="w-5 h-5" data-id="element-117" />
            </a>

            <p className="text-xs text-navy-500 mt-4" data-id="element-118">
              Pago seguro y encriptado. <br data-id="element-119" />
              Entrega digital inmediata a tu correo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}